const RETRY_KEY = 'mobile_auth_state_retry_v1'
interface StateRetry {
  next: string
  original: string
}

/** Preserve the native request's state across one server-authorized linking retry. */
export function mobileCallbackState(state: string | null): string | undefined {
  if (!state) return undefined
  const raw = sessionStorage.getItem(RETRY_KEY)
  if (!raw) return state
  let retry: StateRetry
  try {
    retry = JSON.parse(raw) as StateRetry
  } catch {
    throw new Error('Sign-in recovery is unavailable. Start signing in again.')
  }
  if (
    !retry ||
    typeof retry !== 'object' ||
    typeof retry.next !== 'string' ||
    typeof retry.original !== 'string'
  )
    throw new Error('Sign-in recovery is unavailable. Start signing in again.')
  // A new request never inherits the previous browser attempt's native state.
  return retry.next === state ? retry.original : state
}
export function rememberMobileStateRetry(
  authUrl: string,
  state: string | null,
) {
  const next = new URL(authUrl).searchParams.get('state')
  const original = mobileCallbackState(state)
  if (!next || !original)
    throw new Error('Sign-in retry was incomplete. Start signing in again.')
  sessionStorage.setItem(RETRY_KEY, JSON.stringify({ next, original }))
}
export function clearMobileStateRetry() {
  sessionStorage.removeItem(RETRY_KEY)
}
